import { CompareFn } from 'antd/lib/table/interface';
import { fileIcons } from '~src/config/fileTypeIcons';

import { DbFileVersion, TenderRegistrationPublicVM } from '~src/types/db';
import { parseFileName } from '~src/utils/file';

export interface ShareTableEntry
  extends Pick<DbFileVersion, 'id' | 'name' | 'size' | 'version'> {
  key: string;
  extension: string;
  dbFileVersion: DbFileVersion;
  createdAt: DbFileVersion['created_at'];
  type: typeof fileIcons.doc;
  description: string | null;
}

export const mapDbFileVersionToTableEntry = (
  dbFileVersion: DbFileVersion
): ShareTableEntry => {
  const { id, name, size, version, created_at, description } = dbFileVersion;

  const extension = parseFileName(name).extension || '';

  return {
    id,
    key: id,
    name,
    size,
    version,
    extension,
    createdAt: created_at,
    type: fileIcons[extension || 'default'] || fileIcons.default,
    dbFileVersion,
    description,
  };
};

/** Sorter function - TYPE aka extension column */
export const sortByType: CompareFn<ShareTableEntry> = (a, b) => {
  if (a.extension === b.extension) return 0;
  return (a.extension || '') < (b.extension || '') ? -1 : 1;
};

export type PublicShareStatus = 'private' | 'publicated' | 'revoked';

export const publicShareStatusIntlId: Record<PublicShareStatus, string> = {
  private: 'tender-public-status-private',
  publicated: 'tender-public-status-publicated',
  revoked: 'tender-public-status-revoked',
};

export const getPublicShareStatus = (
  publicShare?: TenderRegistrationPublicVM | null
): PublicShareStatus => {
  if (!publicShare) return 'private';

  if (publicShare.removed_at !== null && publicShare.removed_at !== undefined) {
    return 'revoked';
  }

  return 'publicated';
};
